import { EntryItem } from "../Container/List/EntryItem";

export class ResultItem extends EntryItem {
}
